
import { useState, useEffect } from 'react';
import { Button, Row, Col, Form} from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import { getLocation, updateLocation } from '../../services/Configs/LocationsService'
 

function EditLocationModal({ locationId, show, handleClose, handleReload }) {

  const [formData, setFormData] = useState({
    id: 0,
    locationName: '',
    isActive: false
  })  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  

  const handleUpdateLocation = () => {
    let pendingInputs = [];
    if(!formData.locationName)
    {
        pendingInputs.push("Ubicación")
    }
    if(pendingInputs.length == 0)
    {
        updateLocation(formData.id, formData.locationName, formData.isActive).then(locationResult => {
        toast.success('Ubicación actualizada correctamente');
        handleClose();
        handleReload();
        });
    }
    else
    {
        toast.warning(`Lo sentimos, debes completar los siguientes campos: ${pendingInputs.join(', ')}`)
    }
  }
  useEffect(() => {
    if (show) {
        getLocation(locationId).then(obj => {
            setFormData({
                id: obj.id,
                locationName: obj.name,
                isActive: obj.isActive
            });
        })
    }
  }, [show]);
  return (
    <Modal size="sm" show={show} onHide={handleClose} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>Actualizar ubicación</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
              <Col xl={12} className=' p-2'  >
                <Form.Label>Nombre:</Form.Label>
                          <Form.Group controlId="">
                          <Form.Control
                              type="text"
                              name="locationName"
                              placeholder='Nombre de la ubicación'
                              value={formData.locationName}
                              onChange={handleInputChange}
                          />
                  </Form.Group>
              </Col>
       </Row>
       <Row>
            <Col xl={12}>
                <Form.Group className='mt-3' controlId="formWorkFromHome">
                    <Form.Label>Estatus:</Form.Label>
                    <Form.Check
                        type="radio"
                        label="Activa"
                        name="isActive"
                        value="true"
                        checked={formData.isActive === true}
                        onChange={() => setFormData({ ...formData, isActive: true })}
                    />
                    <Form.Check
                        type="radio"
                        label="Inactiva"
                        name="isActive"
                        value="false"
                        checked={formData.isActive=== false}
                        onChange={() => setFormData({ ...formData, isActive: false })}
                    />
                </Form.Group>
            </Col>
       </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="success" onClick={handleUpdateLocation}>
           Actualizar ubicación
        </Button>
        <Button variant="secondary" onClick={handleClose}>
           Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default EditLocationModal;
